import type { ComponentProps } from 'react';
import React, { useCallback } from 'react';

import { TextField } from '../../TextField';

export const TextFieldZipCode = (props: ComponentProps<typeof TextField>) => {
  const validateChangedText = useCallback((zipCode: string) => {
    return ONLY_NUMBERS_AND_LETTERS.test(zipCode);
  }, []);

  // ────────────────────────────────────────────────────────────────────

  return (
    <TextField
      onChangeTextGuard={validateChangedText}
      autoCapitalize="characters"
      autoCorrect={false}
      textContentType="postalCode"
      keyboardType="default"
      maxLength={8}
      {...props}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ONLY_NUMBERS_AND_LETTERS = /^[\dA-Za-z]*$/;
